import { render, staticRenderFns } from "./CoffeeType.vue?vue&type=template&id=66d396ae&scoped=true&lang=html&"
import script from "./CoffeeType.vue?vue&type=script&lang=js&"
export * from "./CoffeeType.vue?vue&type=script&lang=js&"
import style0 from "./CoffeeType.vue?vue&type=style&index=0&id=66d396ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d396ae",
  null
  
)

export default component.exports